import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewAuditHistoryPageNew from "../../components/Audit History/ViewAuditHistoryPageNew";

const ViewAuditHistoryPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          id="title"
          title2="Audit History"
          link2="/audit-history"
          title="View Audit History"
        />

        <ViewAuditHistoryPageNew />
      </MasterLayout>
    </>
  );
};

export default ViewAuditHistoryPage;
